import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ProjectItemComponent } from './project-item.component';
import { FormControl, FormGroup } from '@angular/forms';

// @Component({
//     // moduleId: module.id.toString(),
//     selector: 'production-contact',
//     templateUrl: 'production-contact.component.html'
// })
export abstract class ProjectItemWithSelectionComponent extends ProjectItemComponent {

    @Input() currentItem: string;
    @Output() selectedItem = new EventEmitter<FormGroup>();

    onItemSelectionChange(event) {
        console.log('entry: ' + JSON.stringify(event.value))  ;
        this.selectedItem.next(event);
        return false;
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/project-item-withselection.component.ts